export default __webpack_public_path__ + "static/waxcarvers-3fe9e8d92eecedbc8192ac9f0dfcd267.png";